// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TypeUtils = require("../types/TypeUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var StripeTypes_Utils = require("./StripeTypes_Utils.bs.js");

var partial_arg = Relude_Option.keep(function (param) {
      return Relude_String.startsWith("tok_", param);
    });

function fromString(param) {
  return Relude_Globals.$great$great(Relude_Option.pure, partial_arg, param);
}

var Id = TypeUtils.MakeCustomOpaqueStringType({
      fromString: fromString,
      toString: Relude_Globals.id
    });

function createdGet(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (prim) {
                              return prim.created;
                            }), Relude_Int.toFloat, param);
              }), StripeTypes_Utils.floatToDate, param);
}

exports.Id = Id;
exports.createdGet = createdGet;
/* Id Not a pure module */
